import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import ExportCenter from 'components/ExportCenter';
// eslint-disable-next-line
export default () => {
  return (
    <ContentLayout>
      <SiteContent>
        <ExportCenter />
      </SiteContent>
    </ContentLayout>
  );
};
